import React, { useEffect, useState } from 'react';
import { EntrevistaDetallesHeader } from './detallesHeader';
import { PageTitle } from '../../../../_metronic/layout/core';
import { KTSVG } from '../../../../_metronic/helpers';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useAuth } from '../../../modules/auth';
import { useParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL;

type Etiqueta = {
    hijos: any; nombre: string, _id: String
};
type EtiquetasProp = Etiqueta[];

const Etiquetas: React.FC = () => {
    const { id } = useParams();
    const [keyListEtiqueta, setKeyListEtiqueta] = useState<number | null>(1)
    const [tituloModal, setTituloModal] = useState<string | null>(null);
    const [listEtiquetas, setListEtiquetas] = useState<EtiquetasProp | []>([]);
    const [newEtiquetas, setNewEtiquetas] = useState<string[]>([])
    const [etiquetaSelected, setEtiquetaSelected] = useState<number | null>(null);
    const [entrevistaData, setEntrevistaData] = useState<any | null>(null);
    const auth = useAuth();

    const addEtiqueta = async (url: string, e: string) => {
        try {
            const response = await fetch(url, {
                method: 'POST',
                body: JSON.stringify({ analisisId: e, id: id }),
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': auth.auth?.api_token!
                }
            });

            const jsonResponse = await response.json();

            if (response.status >= 200 && response.status < 300) {
                //console.log("Before update:", entrevistaData)
                setEntrevistaData((prevData: any) => {
                    const newEntrevistaData = {
                        ...prevData,
                        analisisContexto: jsonResponse.data,
                    };
                    return newEntrevistaData;
                });
                //await updateEtiquetas();
                //console.log("After update:", entrevistaData)
                //await loadEtiquetasEntrevista();
            } else {
                console.log(jsonResponse);
            }
        } catch (err) {
            console.log("se murio");
        }
    };

    const saveNewEtiquetas = async () => {
        console.log(newEtiquetas);
        let url = "";
        switch (etiquetaSelected) {
            case 1:
                url = `${API_URL}/entrevista/saveAnalisisContexto`
                break;
            case 2:
                url = `${API_URL}/entrevista/saveEstrategias`
                break;
            case 3:
                url = `${API_URL}/entrevista/saveConsecuencias`
                break;
            case 4:
                url = `${API_URL}/entrevista/saveFactores`
                break;
            case 5:
                url = `${API_URL}/entrevista/saveCausas`
                break;
        }
        try {
            const response = await fetch(url, {
                method: 'POST',
                body: JSON.stringify({ etiquetas: newEtiquetas, id: id }),
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': auth.auth?.api_token!
                }
            });

            const jsonResponse = await response.json();

            if (response.status >= 200 && response.status < 300) {
                await loadEtiquetasEntrevista();
                setTituloModal(null)
            } else {
                console.log(jsonResponse);
            }
        } catch (err) {
            console.log("se murio");
        }
    }

    const updateEtiquetas = async (e: string) => {
        // Create a new array based on the current state
        console.log(e)
        const updatedEtiquetas = [...newEtiquetas];

        const checkExists = updatedEtiquetas.find((val: string) => val === e)

        if (checkExists) {
            console.log("Existe, se elimina")
            updatedEtiquetas.map((element, key) => {
                if (element === e)
                    updatedEtiquetas.splice(key, 1)
            });
        } else {
            // Push the new element into the array
            updatedEtiquetas.push(e);
        }
        // Update the state with the new array
        setNewEtiquetas(updatedEtiquetas);
    };



    const loadEtiquetas = async (url: string, etiquetaSelected: number, title: string) => {
        setEtiquetaSelected(etiquetaSelected);
        try {
            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': auth.auth?.api_token!,
                },
            });

            if (!response.ok) {
                throw Error(response.statusText);
            }

            const data = await response.json();

            await data.data.forEach(async (item: any) => {
                let etiquetaMap;

                switch (etiquetaSelected) {
                    case 1:
                        etiquetaMap = entrevistaData.orden.analisisContexto
                        break;
                    case 2:
                        etiquetaMap = entrevistaData.orden.estrategias
                        break;
                    case 3:
                        etiquetaMap = entrevistaData.orden.consecuencias
                        break;
                    case 4:
                        etiquetaMap = entrevistaData.orden.factores
                        break;
                    case 5:
                        etiquetaMap = entrevistaData.orden.causas
                        break;
                }

                //console.log("Etiqueta: ",etiquetaMap);
                //console.log(item);

                const matchingVal = await etiquetaMap.find((val: any) => val.id === item._id);

                //console.log(matchingVal)

                if (matchingVal) {
                    matchingVal.children.forEach((child: any) => {
                        item.hijos.forEach((hijo: any) => {
                            if (child._id === hijo._id) {
                                hijo.checked = true;
                                hijo.childId = child._id;
                            }
                        });
                    });
                }

                await Promise.all(item.hijos.map(async (hijo: any) => {
                    if (hijo.checked === undefined) {
                        hijo.checked = false;
                    }
                }));
            });

            let newEti;
            let salvado;

            switch (etiquetaSelected) {
                case 1:
                    //console.log(entrevistaData.desorden.analisisContexto)
                    newEti = entrevistaData.desorden?.analisisContexto || [];
                    salvado = newEti.map((item: any) => item.id);
                    setNewEtiquetas(salvado);
                    break;
                case 2:
                    //console.log(entrevistaData.desorden.analisisContexto)
                    newEti = entrevistaData.desorden?.estrategias || [];
                    salvado = newEti.map((item: any) => item.id);
                    setNewEtiquetas(salvado);
                    break;
                case 3:
                    //console.log(entrevistaData.desorden.analisisContexto)
                    newEti = entrevistaData.desorden?.consecuencias || [];
                    salvado = newEti.map((item: any) => item.id);
                    setNewEtiquetas(salvado);
                    break;
                case 4:
                    //console.log(entrevistaData.desorden.analisisContexto)
                    newEti = entrevistaData.desorden?.factores || [];
                    salvado = newEti.map((item: any) => item.id);
                    setNewEtiquetas(salvado);
                    break;
                case 5:
                    //console.log(entrevistaData.desorden.analisisContexto)
                    newEti = entrevistaData.desorden?.causas || [];
                    salvado = newEti.map((item: any) => item.id);
                    setNewEtiquetas(salvado);
                    break;
            }

            setListEtiquetas(data.data);
            setTituloModal(title);
        } catch (err) {
            console.log(err);
        }
    };

    const loadAnalisisContexto = async () => {
        await loadEtiquetas(`${API_URL}/etiqueta/getAnalisisContexto`, 1, 'Análisis de Contexto');
    };

    const loadEstrategias = async () => {
        await loadEtiquetas(`${API_URL}/etiqueta/getEstrategias`, 2, 'Estrategias');
    };

    const loadConsecuencias = async () => {
        await loadEtiquetas(`${API_URL}/etiqueta/getConsecuencias`, 3, 'Consecuencias');
    };

    const loadFactores = async () => {
        await loadEtiquetas(`${API_URL}/etiqueta/getFactores`, 4, 'Factores de Persistencia');
    };

    const loadCausas = async () => {
        await loadEtiquetas(`${API_URL}/etiqueta/getCausas`, 5, 'Causas');
    };

    const loadEtiquetasEntrevista = async () => {
        try {
            const response = await fetch(`${API_URL}/entrevista/getEtiquetasEntrevista`, {
                method: 'POST',
                body: JSON.stringify({ id: id }),
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': auth.auth?.api_token!
                }
            });
            const jsonResponse = await response.json();
            if (response.status >= 200 && response.status < 300) {
                //console.log(jsonResponse)
                await setEntrevistaData(jsonResponse)
                //await setNewEtiquetas(jsonResponse.desorden)
            }
            else {
                console.log(response.statusText);
            }
        } catch (err) {
            console.error('Error fetching etiquetas:', err);
        }
    }

    useEffect(() => {
        loadEtiquetasEntrevista()
    }, [])

    return (
        <>
            <PageTitle>Etiquetas de la Entrevista</PageTitle>
            <div className="card mb-5 mb-xl-10">
                <div className="card-header">
                    <EntrevistaDetallesHeader id={id} />
                </div>
                <div className="card-body">
                    <Row>
                        <Col md={3} className='py-5'>
                            <Button onClick={loadAnalisisContexto} className="btn btn-flex btn-primary w-100">
                                <KTSVG
                                    path="/media/icons/duotune/text/txt009.svg"
                                    className="svg-icon svg-icon-3x"
                                />
                                <span className="d-flex flex-column align-items-start ms-2">
                                    <span className="fs-3 fw-bolder">Análisis de contexto</span>
                                </span>
                            </Button>
                        </Col>
                        <Col md={3} className='py-5 center'>
                            <Button onClick={loadEstrategias} className="btn btn-flex btn-primary w-100">
                                <KTSVG
                                    path="/media/icons/duotune/text/txt009.svg"
                                    className="svg-icon svg-icon-3x"
                                />
                                <span className="d-flex flex-column align-items-start ms-2">
                                    <span className="fs-3 fw-bolder">Estrategias</span>
                                </span>
                            </Button>
                        </Col>
                        <Col md={3} className='py-5'>
                            <Button onClick={loadConsecuencias} className="btn btn-flex btn-primary w-100">
                                <KTSVG
                                    path="/media/icons/duotune/text/txt009.svg"
                                    className="svg-icon svg-icon-3x"
                                />
                                <span className="d-flex flex-column align-items-start ms-2">
                                    <span className="fs-3 fw-bolder">Consecuencias</span>
                                </span>
                            </Button>
                        </Col>
                        <Col md={3} className='py-5'>
                            <Button onClick={loadCausas} className="btn btn-flex btn-primary w-100">
                                <KTSVG
                                    path="/media/icons/duotune/text/txt009.svg"
                                    className="svg-icon svg-icon-3x"
                                />
                                <span className="d-flex flex-column align-items-start ms-2">
                                    <span className="fs-3 fw-bolder">Causas</span>
                                </span>
                            </Button>
                        </Col>
                        <Col md={3} className='py-5'>
                            <Button className="btn btn-flex btn-primary w-100">
                                <KTSVG
                                    path="/media/icons/duotune/text/txt009.svg"
                                    className="svg-icon svg-icon-3x"
                                />
                                <span className="d-flex flex-column align-items-start ms-2">
                                    <span className="fs-3 fw-bolder">Responsables</span>
                                </span>
                            </Button>
                        </Col>
                        <Col md={3} className='py-5'>
                            <Button onClick={loadFactores} className="btn btn-flex btn-primary w-100">
                                <KTSVG
                                    path="/media/icons/duotune/text/txt009.svg"
                                    className="svg-icon svg-icon-3x"
                                />
                                <span className="d-flex flex-column align-items-start ms-2">
                                    <span className="fs-3 fw-bolder">Factores de persistencia</span>
                                </span>
                            </Button>
                        </Col>
                        <Col md={3} className='py-5'>
                            <Button className="btn btn-flex btn-primary w-100">
                                <KTSVG
                                    path="/media/icons/duotune/text/txt009.svg"
                                    className="svg-icon svg-icon-3x"
                                />
                                <span className="d-flex flex-column align-items-start ms-2">
                                    <span className="fs-3 fw-bolder">Corrupción e impunidad</span>
                                </span>
                            </Button>
                        </Col>
                        <Col md={3} className='py-5'>
                            <Button className="btn btn-flex btn-primary w-100">
                                <KTSVG
                                    path="/media/icons/duotune/text/txt009.svg"
                                    className="svg-icon svg-icon-3x"
                                />
                                <span className="d-flex flex-column align-items-start ms-2">
                                    <span className="fs-3 fw-bolder">Enfoque de género</span>
                                </span>
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>
                            <h3>Análisis de Contexto</h3>
                            {entrevistaData?.orden.analisisContexto?.map((element: any) => (
                                <div key={element.id}>
                                    <h5>{element.nombre}</h5>
                                    <ul>
                                        {element.children.map((child: any) => (
                                            <li key={child._id}>{child.name}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </Col>
                        <Col md={4}>
                            <h3>Estrategias</h3>
                            {entrevistaData?.orden.estrategias?.map((element: any) => (
                                <div key={element.id}>
                                    <h5>{element.nombre}:</h5>
                                    <ul>
                                        {element.children.map((child: any) => (
                                            <li key={child._id}>{child.name}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </Col>
                        <Col md={4}>
                            <h3>Consecuencias</h3>
                            {entrevistaData?.orden.consecuencias?.map((element: any) => (
                                <div key={element.id}>
                                    <h5>{element.nombre}:</h5>
                                    <ul>
                                        {element.children.map((child: any) => (
                                            <li key={child._id}>{child.name}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </Col>
                        <Col md={4}>
                            <h3>Causas</h3>
                            {entrevistaData?.orden.causas?.map((element: any) => (
                                <div key={element.id}>
                                    <h5>{element.nombre}:</h5>
                                    <ul>
                                        {element.children.map((child: any) => (
                                            <li key={child._id}>{child.name}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </Col>
                        <Col md={4}>
                            <h3>Factores de persistencia</h3>
                            {entrevistaData?.orden.factores?.map((element: any) => (
                                <div key={element.id}>
                                    <h5>{element.nombre}:</h5>
                                    <ul>
                                        {element.children.map((child: any) => (
                                            <li key={child._id}>{child.name}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </Col>
                    </Row>
                </div>
            </div>
            <Modal className="modal-lg" show={!!tituloModal} onHide={() => setTituloModal(null)} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Selecciona las etiquetas de {tituloModal}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row key={keyListEtiqueta}>
                        {listEtiquetas.map((item, index) => (
                            <Col md={6} key={index}>
                                <h3>{item.nombre}</h3>
                                {item.hijos.map((post: {
                                    childId: string;
                                    checked: boolean; nombre: string, _id: string
                                }, postIndex: number) => (
                                    <Form.Check
                                        key={post._id}
                                        label={post.nombre}
                                        onChange={() => updateEtiquetas(post._id)}
                                        className='form-check form-switch form-check-custom form-check-solid py-3'
                                        defaultChecked={post.checked}
                                    />
                                ))}
                            </Col>
                        ))}
                    </Row>

                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn btn-danger" onClick={() => setTituloModal(null)}>
                        Cancelar
                    </Button>
                    <Button
                        onClick={saveNewEtiquetas}>Guardar</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export { Etiquetas };